const participantListStyles = (theme) => {
  return {
    root: {
      width: '100%',
      // height: "100%",
      backgroundColor: '#11091E', //#191838
      height: '100%',
      overflowY: 'auto',
      // overflow: "visible !important",
      '&::-webkit-scrollbar': {
        width: 4,
        height: 4,
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
        WebkitBoxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(104,97,88,1)',
        // outline: "1px solid slategrey",
      },
      //   '&:hover': {
      //     '&::-webkit-scrollbar': {
      //       width: 4,
      //       height: 4,
      //     },
      //     '&::-webkit-scrollbar-track': {
      //       boxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
      //       WebkitBoxShadow: 'inset 0 0 2px rgba(0,0,0,0.00)',
      //     },
      //     '&::-webkit-scrollbar-thumb': {
      //       backgroundColor: 'rgba(104,97,88,1)',
      //     },
      //   },
    },
  };
};

export default participantListStyles;
